import { FileManagerInventoryFile } from '../slices/slice_types';
import { RootState } from '../store';

export const selectFileQueueSlice = (state: RootState) => state.fileQueue || {};
export const selectFileQueue = (state: RootState): FileManagerInventoryFile[] => selectFileQueueSlice(state).items || [];
export const selectFileQueueCount = (state: RootState): number => selectFileQueue(state).length;
